import { NiInput, NiModal, NiSelect, NiTable } from '@component/ant-component';
import { BodyGroup } from '@component/body-group';
import ResizableEditor from '@component/business-component/resizable-editor/resizable-editor';
import { AddButton } from '@component/buttons';
import CodeTextArea from '@component/code-textarea/code-textarea';
import { HelperPopover } from '@component/helper-popover';
import { AugmentMeta, defaultAugmentMeta, defaultInferenceConfig, FilteredKnowledge } from '@interface/base';
import React, { useEffect, useRef, useState } from 'react';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { cloneDeep } from 'lodash';
import { NiForm } from '@component/business-component';
import { Button, Col, InputNumber, message, Radio, Row, Slider, Space, Switch, Upload } from 'antd';
import { getAgentInfo, getStructAgentId } from '@lib/quick-func';
import { API } from '@config/api';
import { Connection, CONNECTION_MODE, connectionToLocal } from '@interface/connection';
import { AgentInfo, agentToLocal } from '@interface/agent';
import { localizedString } from '@locale/locale';
import { FrameItem } from '@interface/frame';
import { Attribute } from '@interface/parameter';
import { getFullName } from '@lib/parser';
// import { LLMModel, llmModelToLocal } from '@interface/agent';

interface AugmentMetaProps {
  frame: FrameItem;
  selectedParameters: Attribute[];
  disabled?: boolean;
  data: AugmentMeta;
  onChange: (data: AugmentMeta) => void;
}
export const AugmentMetaComp = ({ frame, selectedParameters, disabled, data, onChange }: AugmentMetaProps) => {

  const [system1Array, setSystem1Array] = useState<Connection[]>([]);
  const [knowledgeAgents, setKnowledgeAgents] = useState<AgentInfo[]>([]);
  useEffect(() => {
    API.connection.getRawConnections()
      .then((res: any) => {
        const conns = (res || []).map(connectionToLocal);
        const system1 = conns.filter((item: Connection) => item.mode === CONNECTION_MODE.SYSTEM1);
        setSystem1Array(system1);
      })
      .catch((err: Error) => {
        message.error(err.message);
      });

    API.knowledge.getDeployed().then((res: any) => (res || []).map(agentToLocal))
      .then((agents: AgentInfo[]) => {
        setKnowledgeAgents(agents);
      }).catch((e: any) => {
        message.warning(e.message);
      });
  }, []);

  const [temperature, setTemperature] = useState<number>(data?.inferenceConfig?.temperature || defaultInferenceConfig.temperature);
  const [topk, setTopk] = useState<number>(data?.inferenceConfig?.topk || defaultInferenceConfig.topk);

  const dataRef = useRef<AugmentMeta>(data);
  useEffect(() => {
    dataRef.current = data;
    setTemperature(data?.inferenceConfig?.temperature || defaultInferenceConfig.temperature);
    setTopk(data?.inferenceConfig?.topk || defaultInferenceConfig.topk);
  }, [data]);

  const [prompt, setPrompt] = useState(data?.prompt || '');
  const promptRef = useRef<string>(prompt);
  useEffect(() => {
    promptRef.current = prompt;
  }, [prompt]);

  const [curCollection, setCurCollection] = useState<FilteredKnowledge | null>(null);
  const collectionRef = useRef<FilteredKnowledge | null>(curCollection);
  useEffect(() => {
    collectionRef.current = curCollection;
  }, [curCollection]);

  const [curCollectionIndex, setCurCollectionIndex] = useState<number>(-1);
  const [collVisible, setCollVisible] = useState<boolean>(false);
  const [editText, setEditText] = useState<string>('');
  const editTextRef = useRef<string>(editText);
  useEffect(() => {
    editTextRef.current = editText;
  }, [editText]);

  const [curFile, setCurFile] = useState<any>(null);

  function updateInferenceConfig(key: string, value: any) {
    onChange({
      ...dataRef.current,
      inferenceConfig: {
        ...dataRef.current.inferenceConfig || defaultInferenceConfig,
        [key]: value
      }
    });
  }

  return <NiForm
    direction="vertical"
    items={[
      // {
      //   key: 'structured-output',
      //   label: 'Structured output',
      //   labelExtra: <Switch
      //     checked={data?.structuredOutput}
      //     disabled={disabled}
      //     onChange={(checked) => onChange({ ...data, structuredOutput: checked })}
      //   />
      // },
      // data?.structuredOutput && {
      //   key: 'target-slot',
      //   label: 'Target slot',
      //   labelExtra: (
      //     <Space>
      //       <NiSelect value={data?.targetSlot}
      //         disabled={disabled}
      //         allowClear
      //         style={{ width: 200 }}
      //         onChange={(value) => {
      //           onChange({
      //             ...data,
      //             targetFrame: !value ? undefined : getFullName(frame),
      //             targetSlot: value
      //           });
      //         }}
      //       >
      //         {
      //           selectedParameters.map((slot) => (
      //             <NiSelect.Option key={slot.name} value={slot.name}>{slot.name}</NiSelect.Option>
      //           ))
      //         }
      //       </NiSelect>
      //     </Space>
      //   )
      // } || undefined,
      {
        key: 'model',
        label: 'Model',
        labelExtra: (
          <Space>
            <NiSelect
              disabled={disabled}
              allowClear
              style={{ width: 200 }}
              value={data?.modelId}
              onChange={(value) => {
                onChange({
                  ...data,
                  modelId: value
                });
              }}
            >
              {
                system1Array.map((conn) => (
                  <NiSelect.Option key={conn.name} value={conn.name}>{conn.name}</NiSelect.Option>
                ))
              }
            </NiSelect>
          </Space>
        )
      },
      {
        key: 'prompt',
        label: 'Prompt',
        labelExtra: <HelperPopover localizedKey="augment_prompt" />,
        content: (
          <ResizableEditor
            language="kotlinTemplate"
            disabled={disabled}
            defaultHeight={240}
            initialValue={prompt || ''}
            onChange={(value) => {
              setPrompt(value);
            }}
            onBlur={() => {
              onChange({ ...data, prompt: promptRef.current });
            }}
          />
        )
      },
      // {
      //   key: 'collections',
      //   label: 'Collections',
      //   labelExtra: <HelperPopover localizedKey="augment_collections" />,
      //   extra: <AddButton
      //     onClick={() => {
      //       setCollVisible(true);
      //       setCurCollection({ source: '', relatedTags: [] });
      //     }}
      //   />,
      //   content: (
      //     <>
      //       <NiTable
      //         pagination={false}
      //         dataSource={data?.contextCollections || []}
      //         rowKey={(record) => record.source || record.knowledgeLabel || ''}
      //         onRow={(record, index) => ({
      //           onClick: () => {
      //             setCollVisible(true);
      //             setCurCollection(record);
      //             setCurCollectionIndex(index || 0);
      //           }
      //         })}
      //         columns={[
      //           {
      //             title: 'Source',
      //             dataIndex: 'source',
      //             render: (source: string) => {
      //               return source.length > 30 ? `${source.slice(0, 30)}...` : source;
      //             }
      //           },
      //           {
      //             title: 'Related Tags',
      //             dataIndex: 'relatedTags',
      //             render: (_, record) => {
      //               const str = JSON.stringify(record);
      //               return str.length > 30 ? `${str.slice(0, 30)}...` : str;
      //             }
      //           },
      //           {
      //             title: '',
      //             className: 'hide',
      //             key: 'operation',
      //             width: 50,
      //             render: (
      //               operation: any,
      //               record: FilteredKnowledge,
      //               index: number
      //             ) => {
      //               return (
      //                 <div className="icon-area">
      //                   {!disabled &&
      //                     <DeleteOutlined
      //                       className="delete-icon"
      //                       onClick={(e) => {
      //                         e.stopPropagation();
      //                         e.preventDefault();
      //                         const next = cloneDeep(dataRef.current) || { prompt: '', contextCollections: [] };
      //                         next.contextCollections?.splice(index, 1);
      //                         onChange(next);
      //                       }}
      //                     />
      //                   }
      //                 </div>
      //               );
      //             }
      //           }
      //         ]}
      //       />
      //       {collVisible && curCollection &&
      //         <NiModal title="Collection"
      //           open={collVisible}
      //           onCancel={() => setCollVisible(false)}
      //           onOk={() => {

      //             if (!collectionRef.current) return;

      //             if (!collectionRef.current.remote && !collectionRef.current.source) {
      //               message.warning('Please upload file');
      //               return;
      //             }

      //             if (collectionRef.current.remote && !collectionRef.current.knowledgeLabel) {
      //               message.warning('Please select knowledge');
      //               return;
      //             }

      //             const next = cloneDeep(dataRef.current) || { prompt: '', contextCollections: [] };

      //             if (!next.contextCollections) {
      //               next.contextCollections = [];
      //             }

      //             if (curCollectionIndex === -1) {
      //               next.contextCollections.push(collectionRef.current);
      //             } else {
      //               next.contextCollections.splice(curCollectionIndex, 1, collectionRef.current);
      //             }
      //             onChange(next);
      //             setCollVisible(false);
      //             setCurFile(null);
      //           }}
      //         >
      //           <NiForm
      //             direction="vertical"
      //             items={[
      //               {
      //                 key: 'remote',
      //                 label: 'Source type',
      //                 content: (
      //                   <Radio.Group onChange={(e: any) => {
      //                     setCurCollection({
      //                       ...collectionRef.current,
      //                       remote: e.target.value
      //                     });
      //                   }}
      //                     value={!!curCollection?.remote}>
      //                     <Radio value={false}>Local</Radio>
      //                     <Radio value={true}>Remote</Radio>
      //                   </Radio.Group>
      //                 )
      //               },
      //               !curCollection?.remote && {
      //                 key: 'source',
      //                 label: 'Source',
      //                 content: (
      //                   <div>
      //                     <Upload
      //                       fileList={curFile ? [curFile] : []}
      //                       beforeUpload={(file) => {
      //                         const reader = new FileReader();
      //                         reader.onload = (e) => {
      //                           if (!collectionRef.current) return;
      //                           if (!e.target || !e.target.result) return;
      //                           const result = e.target.result as string;

      //                           setCurCollection({
      //                             ...collectionRef.current,
      //                             source: result,
      //                             fileType: file.name.split('.').pop()
      //                           });
      //                           setCurFile(file);
      //                         };
      //                         reader.readAsText(file);
      //                         return false;
      //                       }}
      //                     >
      //                       <Button>
      //                         <UploadOutlined /> Select File
      //                       </Button>
      //                     </Upload>
      //                     {curCollection?.source && (
      //                       <div title={curCollection.source} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
      //                         <div style={{ display: 'inline-block', maxWidth: '100%' }}>
      //                           {curCollection.source}
      //                         </div>
      //                       </div>
      //                     )}
      //                   </div>
      //                 ),
      //               } || undefined,
      //               curCollection.remote && {
      //                 key: 'knowledge-label',
      //                 label: 'Knowledge Label',
      //                 labelExtra: <NiSelect
      //                   style={{ width: 200 }}
      //                   key="knowledge"
      //                   allowClear={false}
      //                   placeholder={localizedString('knowledge')}
      //                   value={curCollection.knowledgeLabel}
      //                   onChange={(value: string) => {
      //                     setCurCollection({
      //                       ...collectionRef.current,
      //                       knowledgeLabel: value
      //                     });
      //                   }}
      //                 >
      //                   {
      //                     knowledgeAgents.map((opt: AgentInfo) =>
      //                       <NiSelect.Option key={opt.name} value={opt.name}>
      //                         {opt.name}
      //                       </NiSelect.Option>)
      //                   }
      //                 </NiSelect>
      //               } || undefined,
      //               curCollection.remote && {
      //                 key: 'relatedTags',
      //                 label: 'Related Tags',
      //                 content: (
      //                   <ResizableEditor
      //                     dataId="relatedTags"
      //                     language="json"
      //                     initialValue={JSON.stringify(curCollection?.relatedTags?.reduce((acc: Record<string, string>, cur) => {
      //                       acc[cur.key as string] = cur.value as string;
      //                       return acc;
      //                     }, {} as Record<string, string>))}
      //                     onChange={setEditText}
      //                     onBlur={() => {
      //                       if (!collectionRef.current) return;
      //                       try {
      //                         const nextTags = Object.entries(JSON.parse(editTextRef.current)).map(([key, value]) => ({
      //                           key,
      //                           value: String(value)
      //                         }));
      //                         setCurCollection({
      //                           ...collectionRef.current,
      //                           relatedTags: nextTags
      //                         });
      //                       } catch (error) {
      //                         message.error('Invalid JSON format');
      //                         console.error(error);
      //                       }
      //                     }}
      //                   />
      //                 )
      //               } || undefined
      //             ]}
      //           />
      //         </NiModal>
      //       }
      //     </>
      //   )
      // }
    ]}
  />;
};

